import { useThemeStore, type Theme } from '@/stores/useThemeStore';

export function useTheme() {
  const { theme, setTheme } = useThemeStore();
  return { theme, setTheme };
}

export type { Theme };
